import React from 'react';
import './Instructors.css';
import { instructors } from '../data/instructors';

const Instructors: React.FC = () => {
    return (
        <section className="instructors-section">
            <div className="container">
                <h1 className="page-title">Our Instructors</h1>
                <p className="page-subtitle">
                    Meet the dedicated team guiding you on your Taekwon-Do journey
                </p>

                <div className="instructors-content">
                    {instructors.map((instructor) => (
                        <div key={instructor.id} id={instructor.id} className="instructor-card">
                            <div className="instructor-header">
                                {instructor.image && (
                                    <div className="instructor-image">
                                        <img 
                                            src={instructor.image} 
                                            alt={instructor.name} 
                                            style={instructor.imagePosition ? { objectPosition: instructor.imagePosition } : { objectPosition: 'center top' }}
                                        />
                                    </div>
                                )}
                                <div className="instructor-info">
                                    <h2>{instructor.name}</h2>
                                    <p className="instructor-grade">{instructor.grade}</p>
                                </div>
                            </div>
                            <div className="instructor-bio">
                                {instructor.bio}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Instructors;
